module.exports = __webpack_public_path__ + "img/yajintitle.7ebb504a.png";